// @flow

import sampleFocus from './sampleFocus.formatter';
import groupFormatter from '../../../formatters/group.formatter';
import type { FormatterArgs } from '../../../types';

const formatters = (args?: FormatterArgs): Array<any> =>
  [sampleFocus, groupFormatter].map(formatter => formatter(args));

export default formatters;
